module.exports = __webpack_public_path__ + "img/logo_DT.f83afdf1.svg";